import { useMemo } from 'react'

const TUNISIA_PATH = "M 230 30 L 280 35 L 310 60 L 305 95 L 340 110 L 360 145 L 360 195 L 365 260 L 355 300 L 340 340 L 360 380 L 410 420 L 395 460 L 350 485 L 305 490 L 280 470 L 250 440 L 210 410 L 180 380 L 140 340 L 120 290 L 130 240 L 155 200 L 170 160 L 180 120 L 200 80 L 215 50 Z"

interface MapMiniProps {
  couriers?: number
  height?: number
}

export default function MapMini({ couriers = 8, height = 280 }: MapMiniProps) {
  const pts = useMemo(() =>
    Array.from({ length: couriers }).map((_, i) => ({
      cx: 180 + ((i * 47) % 180),
      cy: 80 + ((i * 83) % 340),
      delay: (i * 0.37) % 2,
    })),
    [couriers]
  )

  return (
    <div className="map-mini" style={{ height }}>
      <svg viewBox="0 0 500 520" preserveAspectRatio="xMidYMid meet">
        <path d={TUNISIA_PATH} fill="rgba(124,179,66,.06)" stroke="rgba(124,179,66,.4)" strokeWidth="1.2" strokeDasharray="3 3" />
        {[
          { x: 280, y: 90,  n: 'Tunis',  major: true  },
          { x: 330, y: 280, n: 'Sfax',   major: true  },
          { x: 310, y: 180, n: 'Sousse', major: false },
          { x: 320, y: 120, n: 'Nabeul', major: false },
          { x: 300, y: 360, n: 'Gabès',  major: false },
          { x: 170, y: 140, n: 'Le Kef', major: false },
          { x: 200, y: 300, n: 'Gafsa',  major: false },
        ].map((c, i) => (
          <g key={i}>
            {c.major && (
              <circle cx={c.x} cy={c.y} r="10" fill="none" stroke="#7CB342" strokeWidth="1.5" opacity=".6">
                <animate attributeName="r" values="5;18;5" dur="2.4s" repeatCount="indefinite" />
                <animate attributeName="opacity" values=".7;0;.7" dur="2.4s" repeatCount="indefinite" />
              </circle>
            )}
            <circle cx={c.x} cy={c.y} r={c.major ? 5 : 3.5} fill="#fff" stroke="#7CB342" strokeWidth="2" />
            <text x={c.x + (c.major ? 10 : 7)} y={c.y + 4}
              fill={c.major ? '#fff' : 'rgba(255,255,255,.7)'}
              fontSize="11" fontFamily="JetBrains Mono"
              fontWeight={c.major ? 700 : 500}>{c.n}</text>
          </g>
        ))}
        {pts.map((p, i) => (
          <g key={i} transform={`translate(${p.cx},${p.cy})`}>
            <circle r="7" fill="none" stroke="#7CB342" strokeWidth="1.5" opacity=".4">
              <animate attributeName="r" values="4;12;4" dur="2s" begin={`${p.delay}s`} repeatCount="indefinite" />
            </circle>
            <circle r="4" fill="#7CB342" stroke="#fff" strokeWidth="1.5" />
          </g>
        ))}
      </svg>
    </div>
  )
}
